class FaqAccordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).click(function(){
      $(this).next().slideToggle();
      $(this).find('.trigger').toggleClass('is-open');
    });
  }
}
